import { createTheme } from '@mui/material/styles';

/** Same palette Ullr uses in src/components/ThemeRegistry/theme.ts. */
const theme = createTheme({
  palette: {
    background: {
      default: '#dddddd',
      paper: '#ffffff',
    },
    primary: {
      main: '#303c6c',
    },
    secondary: {
      main: '#f4976c',
    },
    info: {
      main: '#b4dfe5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#dddddd',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#303c6c',
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          backgroundColor: '#b4dfe5',
          padding: '12px 16px',
        },
        title: {
          fontSize: '1.15rem',
          fontWeight: 500,
        },
        subheader: {
          fontSize: '0.95rem',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 500 },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.severity === 'info' && {
            backgroundColor: '#e0f2fe',
            color: '#01579b',
            '& .MuiAlert-icon': { color: '#0277bd' },
          }),
        }),
      },
    },
  },
});

export default theme;
